import { getBaseURL } from "../../env/stage";
import { TEST_FLOW, TEST_SCRIPT, TOGGLE_LOADING } from "./types";
import { TestFlowTrigger } from "../../common/interfaces/flow/trigger/TestFlowTrigger";
import { post } from "../../common/modules/http.client";
import { addMessage } from "./messageActions";
import { ActionType } from "../../common/interfaces/flow/action/ActionType";

const APP_URL = getBaseURL() + "/testflow";
const TEST_SCRIPT_URL = getBaseURL() + "/flows/action/variable/script/evaluate";
const TEST_SCRIPTED_ACTION_URL = getBaseURL() + "/flows/action/script/evaluate";

export const testFlow = (testFlowTrigger: TestFlowTrigger) => (dispatch: any) => {
  return post(APP_URL, testFlowTrigger)
    .then((res) => {
      dispatch({
        type: TEST_FLOW,
        payload: res,
      });
    })
    .catch(async (err) => {
      let errorMessage = err?.statusText || "Error sending test request to server";
      if (err?.json) {
        try {
          const body = await err.json();
          errorMessage = body?.error || errorMessage;
        } catch (e) {
          // ignore json parse errors
        }
      }
      console.log("err", err);
      return Promise.reject(new Error(errorMessage));
    });
};
export const runTestScripted = (scriptItem: any, scope: any, actionType: ActionType) => (dispatch: any) => {
  const testData = {
    script: scriptItem.script,
    scope: scope,
    name: scriptItem.name,
  };
  const url = actionType === ActionType.SCRIPT_ACTION_TYPE ? TEST_SCRIPTED_ACTION_URL : TEST_SCRIPT_URL;

  post(url, testData)
    .then((res) => {
      dispatch({
        type: TEST_SCRIPT,
        payload: res,
      });
      dispatch({
        type: TOGGLE_LOADING,
        payload: { status: false, loadingMessage: "loading..." },
      });
    })
    .catch((err) => {
      console.log("err", err);
      dispatch(addMessage("Error testing script", err.statusText, "error"));
    });
};

export const clearScriptResult = () => (dispatch: any) => {
  dispatch({
    type: TEST_SCRIPT,
    payload: undefined,
  });
};
